import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export const CATEGORY_LABELS = { stampa: "Stampa", scuola: "Scuola / PCTO", erasmus: "Erasmus VET", adulti: "Adulti" };

export const PricingDialog = ({ open, onClose, pricing, onSaved }) => {
  const [draft, setDraft] = useState(pricing);
  const [saving, setSaving] = useState(false);

  React.useEffect(() => { setDraft(pricing); }, [pricing, open]);
  if (!draft) return null;

  const setPkg = (i, v) => {
    const packages = draft.packages.map((p, ix) => ix === i ? { ...p, price_per_person: parseFloat(v || "0") } : p);
    setDraft({ ...draft, packages });
  };
  const setCat = (k, v) => setDraft({ ...draft, lab_categories: { ...draft.lab_categories, [k]: parseFloat(v || "0") } });

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/pricing", draft);
      onSaved(data);
      toast.success("Listino aggiornato");
      onClose();
    } catch { toast.error("Errore salvataggio listino"); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="pricing-dialog">
        <DialogHeader><DialogTitle className="font-display text-3xl">Listino prezzi</DialogTitle></DialogHeader>
        <div className="space-y-5 text-sm">
          <div>
            <div className="overline mb-2">Pacchetti soggiorno · € a persona</div>
            <div className="grid grid-cols-2 gap-3">
              {draft.packages.map((p, i) => (
                <div key={p.key}><Label>{p.label}</Label><Input type="number" min="0" step="0.5" value={p.price_per_person} onChange={(e) => setPkg(i, e.target.value)} data-testid={`pricing-pkg-${p.key}`} /></div>
              ))}
            </div>
          </div>
          <div>
            <div className="overline mb-2">Laboratori per tipologia · € a persona</div>
            <div className="grid grid-cols-2 gap-3">
              {Object.keys(CATEGORY_LABELS).map((k) => (
                <div key={k}><Label>{CATEGORY_LABELS[k]}</Label><Input type="number" min="0" step="0.5" value={draft.lab_categories[k] ?? 0} onChange={(e) => setCat(k, e.target.value)} data-testid={`pricing-cat-${k}`} /></div>
              ))}
            </div>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={onClose} className="rounded-full">Annulla</Button>
            <Button onClick={save} disabled={saving} className="btn-primary-cdm rounded-full" data-testid="pricing-save">{saving ? "Salvo…" : "Salva listino"}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
